import { IItemList } from "@/components/core/Select";

export const NICHE_SORT_OPTIONS: Record<string, IItemList> = {
  subscribers: { label: "Subscribers", value: "subscribers" },
  posts: { label: "Posts", value: "posts" },
  name: { label: "Name", value: "name" }
} as const;

export const NICHE_SORT_ORDER_OPTIONS = [
  { label: "A-Z", value: "asc" },
  { label: "Z-A", value: "desc" }
];
